export default __webpack_public_path__ + "static/news5-702dc83acc5007d9db610f05d119e4aa.jpeg";